// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2Tgjb","errors":"Errors_errors__VNq_v"};